import React from "react";
import "./FounderBadge.css";

export default function FounderBadge() {
  return (
    <div className="founder-badge">
      <span className="founder-badge__eyebrow">Founder &amp; CEO</span>
      <span className="founder-badge__brand">MUVIA</span>
      <span className="founder-badge__sub">PRODUCTIONS</span>
    </div>
  );
}